import { call, select, put } from 'redux-saga/effects';
import { wms } from '../endpoints';
import { API } from '../../api';
import { transformResults } from './transformers';

const getBaseConfig = ({ serverConfig }) => serverConfig;

export function* fetchParcels(config) {
  const { namespace, version } = yield select(getBaseConfig);

  const path = wms({
    namespace,
    version,
    ...config,
  });

  const results = yield call(API, 'get', 'api', path);

  const transformedResults = transformResults(results);
  yield put({
    type: 'ADD_PARCELS',
    payload: {
      parcels: results.features,
    },
  });
  return transformedResults;
}
export function* fetchWMS(config) {
  const { request, namespace, version } = yield select(getBaseConfig);

  const path = wms({
    request,
    namespace,
    version,
    ...config,
  });

  const results = yield call(API, 'get', 'api', path);

  return results;
}
